import { connectedComponent } from 'utils/redux/providerWrapper';
import FerryTimetable from './ferry_timetable';

const ConnectedFerryTimetable = connectedComponent(FerryTimetable);

export default ConnectedFerryTimetable;
